<template>
  <div>
    <van-popup
      v-model="isShow"
      lock-scroll
      close-on-popstate
      position="right"
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-field
          :label="$t('D020','邮箱')"
          placeholder="请输入邮箱地址"
          v-model="email"
          input-align="left"
          clearable
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'
import { validators } from 'Utils/valid'

export default {
  name: 'EditEmail',
  mixins: [mixin],
  data() {
    return {
      email: ''
    }
  },
  created () {
    this.email = this.empInfo.email
  },
  methods: {
    complie () {
      let valider = validators['email'](this.email)
      if (!valider.valid) {
        this.$toast(valider.msg)
        return
      }
      
      this.empInfo.email = this.email
      this.save()
    }
  }
}
</script>